import { resolveSemanticColor } from '@/theme/semanticTokens';
import { s } from '@/theme/tokens';
import { Box, Stack, Text } from '@/ui';
import type { ReactElement } from 'react';

type ValidationMissingValuesSectionProps = {
  hideTitle?: boolean;
  title: string;
  values: string[];
};

export const ValidationMissingValuesSection = ({
  hideTitle = false,
  title,
  values,
}: ValidationMissingValuesSectionProps): ReactElement | null => {
  if (values.length === 0) return null;

  return (
    <Stack gap="xs">
      {hideTitle ? null : (
        <Text
          role="body"
          sx={(theme) => ({
            fontSize: theme.typography.subtitle1.fontSize,
            lineHeight: theme.typography.subtitle1.lineHeight,
            fontWeight: theme.typography.subtitle1.fontWeight,
          })}
        >
          {title}
        </Text>
      )}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: s('xs') }}>
        {values.map((value, index) => {
          const suffix = index < values.length - 1 ? ',' : '';
          return (
            <Box
              key={`${title}-${value}-${index}`}
              component="span"
              sx={{ display: 'inline-flex' }}
            >
              <Text
                role="body"
                component="span"
                sx={(theme) => ({
                  color: resolveSemanticColor(theme, 'error'),
                  fontSize: theme.typography.subtitle1.fontSize,
                })}
              >
                {value}
              </Text>
              {suffix ? (
                <Text
                  role="body"
                  component="span"
                  color="textSecondary"
                  sx={(theme) => ({ fontSize: theme.typography.subtitle1.fontSize })}
                >
                  {suffix}
                </Text>
              ) : null}
            </Box>
          );
        })}
      </Box>
    </Stack>
  );
};
